import { takeEvery, put, call, select } from 'redux-saga/effects'
import {
  ADD_NEW_ASSIGNMENT,
  CANCEL_EDIT_ASSIGNMENT,
  COPY_ASSIGNMENT,
  DELETE_ASSIGNMENT,
  GET_ASSIGNMENTS,
  GET_ASSIGNMENT_BY_ID,
  SAVE_ASSIGNMENT_AS_DRAFT,
  GET_AREA_OF_WORK,
  GET_EMPLOYER_CONTRACT_LIST,
  PIN_ASSIGNMENT
} from '../../constants/employer'
import { API_SERVER } from '../../constants'
import { apiManualPost, apiManualRequest } from '../../utils/employer/request'
import {
  addNewAssignmentFailed,
  // addNewAssignmentSuccess,
  copyAssignmentFailed,
  copyAssignmentSuccess,
  deleteAssignmentFailed,
  deleteAssignmentSuccess,
  getAssignmentByIdFailed,
  getAssignmentByIdSuccess,
  getAssignments,
  getAssignmentsFailed,
  getAssignmentsSuccess,
  updateAssignmentSuccess,
  // updateAssignmentFailed,
  saveAssignmentAsDraftSuccess,
  saveAssignmentAsDraftFailed,
  addNewAssignmentSuccess,
  getAreaOfWorkSuccess,
  getEmployerContractListSuccess,
  getEmployerContractListFailed,
  openAssignmentFormDialog,
  pinAssignmentSuccess,
  pinAssignmentFailed,
  getOfferFromLightEntre,
  signSendContract
} from '../../actions/employer'
import { updateFormValues, resetForm } from '../../form'
import {
  getAssignmentEdit // getAssignmentFormValues,
  // getSaveDraft
} from '../../selectors/employer/assignments.selector'
import { getUuid } from '../../selectors/employer/client.selector'
import moment from 'moment'
import {
  stringToArray,
  arrayToString,
  cleanAndJoin
} from '../../utils/employer/stringArrayHandle.utils'
import { formatDate } from '../../containers/employer/validate'

// Load assignments
function* getAssignmentsSaga({ isDirectlyOffer }) {
  try {
    const url = `${API_SERVER}/GetAssignmentDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid
    })
    const result = yield call(apiManualPost, url, body)
    const parsedResult = JSON.parse(result.data)
    yield put(getAssignmentsSuccess(parsedResult))
    if (parsedResult) {
      if (isDirectlyOffer) {
        yield put(signSendContract(null, false, null, true))
      }
    }
  } catch (error) {
    yield put(getAssignmentsFailed(error))
  }
}
// Save draft
function* saveAssignmentAsDraftSaga({ values }) {
  try {
    const data = values
    const uuid = yield select(getUuid)
    const assignmentEdit = yield select(getAssignmentEdit)
    let employmenttype = [
      data.weekdays && 'weekdays',
      data.morning && 'morning',
      data.evening && 'evening',
      data.night && 'night',
      data.weekends && 'weekends',
      data.remote && 'remote',
      data.undefined_hours && 'undefined_hours'
    ]
      .filter(Boolean)
      .join(',')

    let body = {
      uuid: uuid,
      jobtitle: data.jobTitle,
      location: data.location,
      assignmenttype: data.assignmentType,
      lastdateapplication: moment(data.lastDate).format('YYYY-MM-DD'),
      employmenttype: employmenttype,
      salarymodel: data.salaryModel,
      assignmentbegins: moment(data.assignmentBegin).format('YYYY-MM-DD'),
      hourlyrate: data.hourlyRate,
      weeklyhours: data.weeklyHours,
      noticeperiod: data.manualNotice,
      amount: data.amount_e,
      unitprice: data.unitPrice,
      salarycontract: data.contractSalary,
      assignmentends: data?.assignmentEnds
        ? moment(data.assignmentEnds).format('YYYY-MM-DD')
        : null,
      jobdescription: data.job_des,
      statusassignment: 'draft'
    }

    let url
    let assignmentid
    if (assignmentEdit.length > 0) {
      assignmentid = assignmentEdit[0].assignment_id
      if (!!assignmentid) {
        url = `${API_SERVER}/UpdateAssignmentDetails`
        body.assignmentid = assignmentid
        const offer_to_e_email = values?.offer_to_e_email
          ? values.offer_to_e_email.filter((el) => el !== '')
          : []
        if (
          values?.offer_to_e_email &&
          offer_to_e_email.length > 0 &&
          offer_to_e_email[0] !== ''
        ) {
          body.entrepreneursemail = arrayToString(offer_to_e_email)
          body.industry = arrayToString(
            data?.offer_to_industry ? data?.offer_to_industry : []
          )

          // industry type of the job for saving purpose
          body.industrytype = body.industry
        } else {
          body.entrepreneursemail = null
          body.industry =
            data?.offer_to_industry === undefined ||
            data?.offer_to_industry[0] === ''
              ? ''
              : arrayToString(data.offer_to_industry)

          // industry type of the job for saving purpose
          body.industrytype = body.industry
        }
      }
    } else if (assignmentEdit.length <= 0) {
      url = `${API_SERVER}/AddNewAssignmentDetails`
      if (
        values?.offer_to_e_email &&
        (values.offer_to_e_email.length > 1 ||
          (values.offer_to_e_email.length === 1 &&
            values.offer_to_e_email[0] !== ''))
      ) {
        body.addMultipleEntrepreneursEmails = [
          {
            entrepreneursemail: values.offer_to_e_email
              .filter((el) => el !== '')
              .join(',')
          }
        ]
        body.industry = values?.offer_to_industry
          ? cleanAndJoin(values.offer_to_industry)
          : ''
        body.industrytype = body.industry
      } else {
        body.addMultipleEntrepreneursEmails = [{ entrepreneursemail: null }]
        body.industry = values?.offer_to_industry
          ? values.offer_to_industry.filter((el) => el !== '').join(',')
          : ''
        body.industrytype = body.industry
      }
    }

    const result = yield call(apiManualPost, url, JSON.stringify(body))
    if (result.data === 'Assignment details are added successfully') {
      yield put(saveAssignmentAsDraftSuccess(result.data))
      yield put(resetForm('assignments'))
    } else if (result.data === 'Assignment details are updated successfully') {
      yield put(updateAssignmentSuccess(result.data))
      yield put(resetForm('assignments'))
    } else {
      yield put(saveAssignmentAsDraftFailed())
    }
    yield put(getAssignments())
    yield put(getOfferFromLightEntre())
  } catch (error) {
    yield put(saveAssignmentAsDraftFailed(error))
  }
}
// Add new assignment
function* addNewAssignmentSaga({ values, isDirectlyOffer }) {
  try {
    const data = values
    const uuid = yield select(getUuid)
    const assignmentEdit = yield select(getAssignmentEdit)

    let employmenttype = [
      data.weekdays && 'weekdays',
      data.morning && 'morning',
      data.evening && 'evening',
      data.night && 'night',
      data.weekends && 'weekends',
      data.remote && 'remote',
      data.undefined_hours && 'undefined_hours'
    ]
      .filter(Boolean)
      .join(',')

    let body = {
      uuid: uuid,
      jobtitle: data.jobTitle,
      // industrytype: data.industryType,
      location: data.location,
      assignmenttype: data.assignmentType,
      lastdateapplication: moment(data.lastDate).format('YYYY-MM-DD'),
      employmenttype: employmenttype,
      salarymodel: data.salaryModel,
      assignmentbegins: moment(data.assignmentBegin).format('YYYY-MM-DD'),
      hourlyrate: data.hourlyRate,
      weeklyhours: data.weeklyHours,
      noticeperiod: data.manualNotice,
      amount: data.amount_e,
      unitprice: data.unitPrice,
      salarycontract: data.contractSalary,
      assignmentends: data?.assignmentEnds
        ? moment(data.assignmentEnds).format('YYYY-MM-DD')
        : null,
      jobdescription: data.job_des,
      statusassignment: 'save'
    }

    let url
    let assignmentid
    if (assignmentEdit.length > 0) {
      assignmentid = assignmentEdit[0].assignment_id
      if (!!assignmentid) {
        url = `${API_SERVER}/UpdateAssignmentDetails`
        body.assignmentid = assignmentid
        const offer_to_e_email = values?.offer_to_e_email
          ? values.offer_to_e_email?.filter((el) => el !== '')
          : []
        if (
          values?.offer_to_e_email &&
          offer_to_e_email.length > 0 &&
          offer_to_e_email[0] !== ''
        ) {
          body.entrepreneursemail = arrayToString(offer_to_e_email)
          body.industry = arrayToString(
            data?.offer_to_industry ? data?.offer_to_industry : []
          )

          // industry type of the job for saving purpose
          body.industrytype = body.industry
        } else {
          body.entrepreneursemail = null
          body.industry =
            data?.offer_to_industry === undefined ||
            data?.offer_to_industry[0] === ''
              ? ''
              : arrayToString(data.offer_to_industry)

          // industry type of the job for saving purpose
          body.industrytype = body.industry
        }
      }
    } else if (assignmentEdit.length <= 0) {
      url = `${API_SERVER}/AddNewAssignmentDetails`
      if (
        values?.offer_to_e_email &&
        (values.offer_to_e_email.length > 1 ||
          (values.offer_to_e_email.length === 1 &&
            values.offer_to_e_email[0] !== ''))
      ) {
        body.addMultipleEntrepreneursEmails = [
          {
            entrepreneursemail: values.offer_to_e_email
              ?.filter((el) => el !== '')
              .join(',')
          }
        ]
        body.industry = values?.offer_to_industry
          ? cleanAndJoin(values.offer_to_industry)
          : ''
        body.industrytype = body.industry
      } else {
        body.addMultipleEntrepreneursEmails = [{ entrepreneursemail: null }]
        body.industry = values?.offer_to_industry
          ? values.offer_to_industry?.filter((el) => el !== '').join(',')
          : ''
        body.industrytype = body.industry
      }
    }

    const result = yield call(apiManualPost, url, JSON.stringify(body))
    if (
      result.data === 'Assignment details are added successfully' ||
      result.data === 'Assignment details are updated successfully'
    ) {
      if (!isDirectlyOffer) {
        yield put(addNewAssignmentSuccess(result.data))
      }
      yield put(resetForm('assignments'))
    } else {
      yield put(addNewAssignmentFailed())
    }
    yield put(getAssignments(isDirectlyOffer))
    yield put(getOfferFromLightEntre())
  } catch (error) {
    yield put(addNewAssignmentFailed(error))
  }
}

// Edit draft assignment
function* editAssignmentSaga({ id }) {
  try {
    const url = `${API_SERVER}/GetAssignmentDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid,
      assignmentid: id
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data) yield put(getAssignmentByIdSuccess(result.data))

    const assignmentResult = JSON.parse(result.data)
    yield put(openAssignmentFormDialog())
    const formData = getFormData(assignmentResult)
    yield put(updateFormValues('assignments', formData))
  } catch (e) {
    yield put(getAssignmentByIdFailed(e))
  }
}

// Copy assignment
function* copyAssignmentSaga({ id }) {
  try {
    const url = `${API_SERVER}/CopyAssignmentDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid,
      assignmentid: id
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data) yield put(copyAssignmentSuccess(result.data))

    const assignmentResult = JSON.parse(result.data)
    const formData = getFormData(assignmentResult)
    if (formatDate(formData.lastDate) < formatDate(new Date())) {
      formData.assignmentBegin = new Date()
      formData.assignmentEnds = new Date()
      formData.lastDate = new Date()
    }

    yield put(updateFormValues('assignments', formData))
  } catch (e) {
    yield put(copyAssignmentFailed(e))
  }
}

function getFormData(result) {
  const { ...result_ } = result[0]
  const formData = {
    ...result_
  }
  const work_shifts = formData.type_of_employment

  formData.jobTitle = formData.job_title
  formData.assignmentType = formData.assignment_type
  formData.salaryModel = formData.salary_model
  formData.industryType = formData.industry_type
  formData.lastDate = formData.last_date_of_application
  formData.assignmentBegin = formData.assignment_begins
  formData.location = formData.location
  formData.hourlyRate = formData.hourly_rate
  formData.weeklyHours = formData.weekly_hours
  formData.assignmentEnds =
    formData.assignment_ends === null ? null : formData.assignment_ends
  formData.manualNotice = formData.notice_period
  formData.contractSalary = formData.contract_salary
  formData.unitPrice = formData.unit_price
  formData.job_des = formData.job_description
  formData.offer_to_e_email =
    formData.enterpreneur_email === null
      ? []
      : formData.enterpreneur_email.split(',')
  // formData.offer_to_e_email = []
  formData.offer_to_industry = stringToArray(formData.industry_type)
  const workShiftTypes = [
    'weekdays',
    'morning',
    'evening',
    'night',
    'weekends',
    'remote',
    'undefined_hours'
  ]
  workShiftTypes.forEach((shift) => {
    formData[shift] = work_shifts.includes(shift)
  })
  formData.amount_e = formData.amount

  const newFormData = Object.keys(formData).reduce((obj, key) => {
    const value = formData[key]
    obj[key] = value === null || value === undefined ? '' : value
    return obj
  }, {})
  return newFormData
}

// Cancel edit assignment
function* cancelEditAssignmentSaga() {
  try {
    yield put(resetForm('assignments'))
  } catch (error) {}
}

// Delete assignment
function* deleteAssignmentSaga({ id }) {
  try {
    const url = `${API_SERVER}/DeleteAssignmentDetails`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid,
      assignmentid: id
    })
    const result = yield call(apiManualPost, url, body)

    if (result.data) {
      yield put(deleteAssignmentSuccess(result.data))
      // Update table grid after delete
      yield put(getAssignments())
      yield put(getOfferFromLightEntre())
    }
  } catch (error) {
    yield put(deleteAssignmentFailed(error))
  }
}

function* getAreaOfWorkSaga() {
  try {
    const url = `${API_SERVER}/GetAreaOfWork/en`
    const result = yield apiManualRequest(url)
    const parRes = JSON.parse(result.data)
    yield put(getAreaOfWorkSuccess(parRes))
  } catch (error) {}
}

function* getEmployerContractListSaga() {
  try {
    const url = `${API_SERVER}/GetEmployerContractList`
    const uuid = yield select(getUuid)
    const body = JSON.stringify({
      uuid: uuid
    })

    const result = yield call(apiManualPost, url, body)
    const parsedResult = JSON.parse(result.data)
    if (result.data) yield put(getEmployerContractListSuccess(parsedResult))
  } catch (error) {
    yield put(getEmployerContractListFailed(error))
  }
}

// Pin assignment
function* pinAssignmentSaga({ assignment_id }) {
  try {
    const url = `${API_SERVER}/AddPinnedAssignmentDetails`
    const uuid = yield select(getUuid)

    const body = JSON.stringify({
      uuid: uuid,
      assignmentid: assignment_id
    })

    const result = yield call(apiManualPost, url, body)
    if (result.data === 'Pinned assignment details are added successfully') {
      yield put(pinAssignmentSuccess(result.data))
    } else {
      yield put(pinAssignmentFailed(result.data))
    }
    yield put(getAssignments())
    yield put(getOfferFromLightEntre())
  } catch (error) {
    yield put(pinAssignmentFailed(error))
  }
}

export function* watchGetAssignmentsSaga() {
  yield takeEvery(GET_ASSIGNMENTS, getAssignmentsSaga)
}
export function* watchAddNewAssignmentSaga() {
  yield takeEvery(ADD_NEW_ASSIGNMENT, addNewAssignmentSaga)
}
export function* watchEditAssignmentSaga() {
  yield takeEvery(GET_ASSIGNMENT_BY_ID, editAssignmentSaga)
}
export function* watchCancelEditAssignmentSaga() {
  yield takeEvery(CANCEL_EDIT_ASSIGNMENT, cancelEditAssignmentSaga)
}
export function* watchDeleteAssignmentSaga() {
  yield takeEvery(DELETE_ASSIGNMENT, deleteAssignmentSaga)
}
export function* watchCopyAssignmentSaga() {
  yield takeEvery(COPY_ASSIGNMENT, copyAssignmentSaga)
}
export function* watchSaveAssignmentAsDraftSaga() {
  yield takeEvery(SAVE_ASSIGNMENT_AS_DRAFT, saveAssignmentAsDraftSaga)
}
export function* watchGetAreaOfWorkSaga() {
  yield takeEvery(GET_AREA_OF_WORK, getAreaOfWorkSaga)
}
export function* watchGetEmployerContractListSaga() {
  yield takeEvery(GET_EMPLOYER_CONTRACT_LIST, getEmployerContractListSaga)
}
export function* watchPinAssignmentSaga() {
  yield takeEvery(PIN_ASSIGNMENT, pinAssignmentSaga)
}
